// extracted by mini-css-extract-plugin
export default {"vehiclesWrapper":"styles_vehiclesWrapper__lPQC+"};